export const CASINOHUB_TESTIDS = {
    searchItem: 'search-hub-item',
    homeItem: 'home-hub-item',
    casinoGamesItem: 'casino-games-hub-item',
    slotsItem: 'slots-hub-item',
    promotionsItem: 'promotions-hub-item',
    hallOfFameItem: 'hall-of-fame-hub-item',
    liveCasinoItem: 'live-casino-hub-item'
};

export const CASHIER_TESTIDS = {
    depositItems: 'deposit-hub-item',
    withdrawItem: 'withdraw-hub-item',
    transactionsItem: 'transactions-hub-item',
    betsItem: 'bets-hub-item',
    limitsItem: 'cashier-limits-hub-item'
};

export const PLAYER_TESTIDS = {
    dashboardItem: 'dashboard-hub-item',
    verificationItem: 'verification-hub-item',
    limitsItem: 'limits-hub-item',
    settingsItem: 'settings-hub-item'
};

export const mfeReadyEvent = 'micro-frontend-ready';
